interface PathParams{
  clientId: string;
  url: string;
  redirectUri: string;
};
const hostname = window.location.hostname;

const API_MAP: { [key: string]: string } = {
  'alumni.dev.cloud.myversant.com': 'https://api.dev.cloud.myversant.com',
  'alumni.qa.cloud.myversant.com': 'https://api.qa.cloud.myversant.com',
  'alumni.prd.cloud.myversant.com': 'https://api.prd.cloud.myversant.com',
  'alumni.myversant.com': 'https://api.myversant.com',
  'localhost': 'https://us-east-1.api.dev.cloud.myversant.com'
};

const COGNITO_MAP: {[key:string]: PathParams} = {
  'localhost': {
    clientId: '6g2a669kr3ottkjl2jd73ltus1', 
    url: 'https://us-east-1.auth.dev.cloud.myversant.com', 
    redirectUri: 'https://cdn.dev.cloud.myversant.com'
  },
  'alumni.dev.cloud.myversant.com': {
    clientId: '6g2a669kr3ottkjl2jd73ltus1', 
    url: 'https://us-east-1.auth.dev.cloud.myversant.com', 
    redirectUri: 'https://cdn.dev.cloud.myversant.com'
  },
  'alumni.qa.cloud.myversant.com': {
    clientId: '7v7i7lpnbnmi8ke3gpn6dn0894', 
    url: 'https://us-east-1.auth.qa.cloud.myversant.com', 
    redirectUri: 'https://cdn.qa.cloud.myversant.com'
  },
  'alumni.prd.cloud.myversant.com': {
    clientId: '6dv1j28qv0igoi41vd97gktti9', 
    url: 'https://us-east-1.auth.prd.cloud.myversant.com', 
    redirectUri: 'https://cdn.prd.cloud.myversant.com'
  },
  'alumni.myversant.com': {
    clientId: '6dv1j28qv0igoi41vd97gktti9', 
    url: 'https://auth.myversant.com', 
    redirectUri: 'https://myversant.com'
  },
};

const API_PATH = API_MAP[hostname]
const COGNITO_PATH = COGNITO_MAP[hostname]
const MAINTENANCE_PAGE = "http://maintenance.vsnt.net/";

export { API_PATH, COGNITO_PATH, MAINTENANCE_PAGE };